import { render, staticRenderFns } from "./admin.layout.vue?vue&type=template&id=6219205a&scoped=true"
import script from "./admin.layout.vue?vue&type=script&lang=js"
export * from "./admin.layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219205a",
  null
  
)

export default component.exports